import { render, staticRenderFns } from "./judgeNode_node_form.vue?vue&type=template&id=52da1a28&"
import script from "./judgeNode_node_form.vue?vue&type=script&lang=js&"
export * from "./judgeNode_node_form.vue?vue&type=script&lang=js&"
import style0 from "./judgeNode_node_form.vue?vue&type=style&index=0&id=52da1a28&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports